import { render, staticRenderFns } from "./EditTaskAction.vue?vue&type=template&id=58c17c02&scoped=true"
import script from "./EditTaskAction.vue?vue&type=script&lang=ts"
export * from "./EditTaskAction.vue?vue&type=script&lang=ts"
import style0 from "./EditTaskAction.vue?vue&type=style&index=0&id=58c17c02&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c17c02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58c17c02')) {
      api.createRecord('58c17c02', component.options)
    } else {
      api.reload('58c17c02', component.options)
    }
    module.hot.accept("./EditTaskAction.vue?vue&type=template&id=58c17c02&scoped=true", function () {
      api.rerender('58c17c02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/projects/activities/EditTaskAction.vue"
export default component.exports